import { makeStyles } from "src/makeStyles";

const useStyles = makeStyles()((theme) => ({
  main: {
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up("lg")]: {
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  },
  root: {
    [theme.breakpoints.down("lg")]: {
      top: "0 !important",
      transform: "translateY(10%)",
      backgroundColor: theme.palette.background.default
    },
    [theme.breakpoints.down("md")]: {
      transform: "translateY(10%)"
    },
    maxWidth: "1045px",
    padding: "0",
    backgroundColor: `${theme.logoBackground}66`, // 66 represents transparency for hex
    borderRadius: "10px",
    height: "500px"
  },
  containerFormInterior: {
    display: "flex",
    maxWidth: "332px",
    margin: "0 auto"
  },
  form: {
    width: "500px"

  },
  linkForgot: {
    display: "block",
    textAlign: "center",
    textTransform: "uppercase",
    marginTop: "20px",
    textDecoration: "none"
  },
  innerGrid: {
    marginTop: "2rem"
  },
  wrappImages: {
    display: "block",
    width: "545px",
    height: "500px"
  },
  imageLogo: {
    [theme.breakpoints.down("lg")]: {
      width: "486px",
      margin: "0 auto auto"
    },
    [theme.breakpoints.down("md")]: {
      width: "360px",
      marginTop: 0
    },
    [theme.breakpoints.down("sm")]: {
      width: "280px"
    },
    width: "344px",
    margin: "147px auto auto",
    display: "block"
  },
  imageClickIcon: {
    [theme.breakpoints.down("lg")]: {
      width: "110px",
      margin: "82px auto 82px auto"
    },
    [theme.breakpoints.down("md")]: {
      width: "100px",
      margin: "62px auto 62px auto"
    },
    [theme.breakpoints.down("sm")]: {
      width: "80px",
      margin: "32px auto 32px auto"
    },
    color: theme.clickIconColor,
    width: "100px",
    height: "100px",
    margin: "62px auto auto",
    display: "block"
  },
  imageCoffeeIcon: {
    width: "18px",
    marginLeft: "15px"
  },
  containerForm: {
    [theme.breakpoints.down("lg")]: {
      borderRadius: "10px",
      width: "70%"
    },
    [theme.breakpoints.down("md")]: {
      width: "86%"
    },
    [theme.breakpoints.down("sm")]: {
      borderRadius: "0"
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "500px"
    },
    width: "500px",
    backgroundColor: theme.palette.common.white,
    borderRadius: "0 10px 10px 0",
    height: "500px"
  },
  "@media (max-width: 1279px)": {
    root: {
      width: "100%",
      height: "100%"
    },
    space: {
      [theme.breakpoints.down("lg")]: {
        minWidth: "100%",
        left: 0
      },
      position: "absolute",
      top: "0",
      left: "10%",
      transform: "initial",
      minWidth: "80%",
      borderRadius: "0"
    }
  },
  "@media (max-width: 768px)": {
    space: {
      position: "absolute",
      top: "0",
      left: "0",
      transform: "initial",
      borderRadius: "0"
    }
  },
  loginButton: {
    padding: "10px 20px",
    width: "100%",
    height: "36px",
    background: theme.palette.primary.contrastText,
    borderRadius: "4px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "16px",
    alignItems: "center",
    textAlign: "center",
    letterSpacing: "1.25px",
    textTransform: "uppercase",
    color: theme.buttonColor,
    marginTop: "10px"
  },
  outerGrid: {
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      padding: "56px 0 66px 0"
    }
  },
  spinner: {
    color: theme.palette.common.white
  },
  field: {
    "&:-webkit-autofill, &-webkit-autofill:hover": {
      WebkitBoxShadow: "0 0 0 30px white inset !important"
    }
  },
  containerImage: {
    [theme.breakpoints.up("lg")]: {
      maxWidth: "545px"
    }
  }
}));

export default useStyles;
